import update from 'immutability-helper';
import guid from "rc-util/es/guid";
export var getParentKey = function getParentKey(key, tree) {
  var parentKey;
  for (var i = 0; i < tree.length; i++) {
    var node = tree[i];
    if (node.children) {
      if (node.children.some(function (item) {
        return item.key === key;
      })) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};
export var editNode = function editNode(node, data) {
  return data === null || data === void 0 ? void 0 : data.map(function (item) {
    if (item.key === node.key) {
      return update(item, {
        $merge: {
          isEditable: true,
          disabled: true,
          title: item.title
        }
      });
    }
    var _children = item.children;
    if (_children) {
      return update(item, {
        children: function children() {
          return editNode(node, _children);
        }
      });
    }
    return item;
  });
};
export var saveNode = function saveNode(node, data) {
  return data.map(function (item) {
    if (item.key === node.key) {
      return update(item, {
        $merge: {
          title: item.title,
          isEditable: false,
          disabled: false
        }
      });
    }
    var _children2 = item.children;
    if (_children2) {
      return update(item, {
        children: function children() {
          return saveNode(node, _children2);
        }
      });
    }
    return item;
  });
};
export var deleteNode = function deleteNode(node, data) {
  return data.map(function (item) {
    if (item.key === node.key) {
      return null;
    }
    var _children3 = item.children;
    if (_children3) {
      return update(item, {
        children: function children() {
          return deleteNode(node, _children3).filter(function (x) {
            return x !== null;
          });
        }
      });
    }
    return item;
  });
};
export var changeNode = function changeNode(node, newNodeObj, data) {
  return data.map(function (item) {
    if (item.key === node.key) {
      return update(item, {
        $merge: newNodeObj
      });
    }
    var _children4 = item.children;
    if (_children4) {
      return update(item, {
        children: function children() {
          return changeNode(node, newNodeObj, _children4);
        }
      });
    }
    return item;
  });
};
export var addNode = function addNode(node, data) {
  return data.map(function (item) {
    if (item.key === node.key) {
      var dataNode = {
        key: "".concat(node.key).concat(guid()),
        title: '',
        isEditable: true
      };
      return update(item, {
        children: function children(_children5) {
          return update(_children5 || [], {
            $push: [dataNode]
          });
        }
      });
    }
    if (item.children) {
      return update(item, {
        children: function children() {
          return addNode(node, item.children);
        }
      });
    }
    return item;
  });
};